import { useDispatch } from 'react-redux';
import { postReferAFriend } from '../../store/actions/referralCode/referralCodeActions';

export const useReferAFriendEvent = () => {
  const dispatch = useDispatch();

  return (account, referees, onSuccess, onError) => {
    dispatch(
      postReferAFriend({
        accountUid: account?.AccountUid,
        referees,
        onSuccess,
        onError,
      }),
    );
  };
};
